/**
 * Taille lisible en unités françaises (o / Ko / Mo / Go / To).
 *
 * Rend une chaîne VIDE pour 0 ou pour une taille absente : dans une colonne de
 * liste de mails, « 0 o » est du bruit. Les écrans qui veulent afficher un zéro
 * explicite (un bilan de stockage, par exemple) le font eux-mêmes — cf.
 * `SpacesOverviewPanel`.
 *
 * Vit dans `utils/` et non dans `features/folder-detail/mailColumns` : l'onglet
 * d'administration en a besoin lui aussi, et importer un module de colonnes de
 * mails — qui porte au passage un store zustand — depuis un écran de réglages
 * n'aurait aucun sens.
 */
export function humanFileSize(bytes: number | null | undefined): string {
  if (!bytes || bytes <= 0) return '';
  const units = ['o', 'Ko', 'Mo', 'Go', 'To'];
  let n = bytes;
  let i = 0;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i += 1;
  }
  return `${i === 0 ? n : n < 10 ? n.toFixed(1) : Math.round(n)} ${units[i]}`;
}
